var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"lottie-card",staticStyle:{"position":"fixed","z-index":"999","background-color":"rgba(255, 255, 255, 0.5)","width":"100%"}},[_c('Lottie',{staticStyle:{"height":"100vh"},attrs:{"width":300,"options":_vm.animationOptions},on:{"animCreated":_vm.handleAnimation}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }